<div class="container-fluid estados-muestras">
  <input
    #scannerInput
    type="text"
    class="scanner-input"
    placeholder="Buscar con lector de código de barras"
    (change)="buscarConScanner(scannerInput.value, detalleModal); scannerInput.value = ''">

  <section class="hero-card">
    <div class="hero-card__content">
      <div class="brand-mark">
        <img src="assets/img/brand/logocm.png" alt="C&M">
      </div>
      <div>
        <h2>Estados de muestras</h2>
        <p>Seguimiento operativo en tiempo real para tomas, facturación y atención de laboratorio.</p>
      </div>
    </div>

    <div class="hero-card__side">
      <span [class]="socketClass()">
        <i class="fa fa-circle"></i>
        Tiempo real: {{ socketStatus }}
      </span>
      <button type="button" class="btn btn-light btn-sm" (click)="cargarItems()" [disabled]="loading">
        <i class="fa fa-refresh"></i>
        Actualizar
      </button>
    </div>
  </section>

  <section class="metrics-grid">
    <article class="metric-card metric-card--primary">
      <span>Total registros</span>
      <strong>{{ totalRows }}</strong>
      <small>{{ totalFiltrados }} visibles con filtros</small>
    </article>
    <article class="metric-card">
      <span>Facturados</span>
      <strong>{{ totalFacturados }}</strong>
      <small>Listos para toma / proceso</small>
    </article>
    <article class="metric-card">
      <span>En laboratorio</span>
      <strong>{{ totalEnLaboratorio }}</strong>
      <small>Procesándose actualmente</small>
    </article>
    <article class="metric-card">
      <span>Retirados</span>
      <strong>{{ totalRetirados }}</strong>
      <small>Ciclo completado</small>
    </article>
  </section>

  <div *ngIf="error" class="alert alert-danger alert-modern">
    <i class="fa fa-exclamation-triangle"></i>
    {{ error }}
  </div>

  <section class="data-card">
    <div class="data-card__header">
      <div>
        <h5>Tomas registradas</h5>
        <p>Haz clic sobre el paciente para revisar los exámenes a realizar.</p>
      </div>
      <div class="data-card__actions">
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="limpiarFiltros()" [disabled]="!hasActiveFilters">
          <i class="fa fa-eraser"></i>
          Limpiar filtros
        </button>
      </div>
    </div>

    <div *ngIf="loading" class="loading-state">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Cargando...</span>
      </div>
      <span>Cargando estados de muestras...</span>
    </div>

    <div class="table-responsive status-table-wrapper" *ngIf="!loading">
      <table class="table status-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Sucursal</th>
            <th>Paciente</th>
            <th>Estado</th>
            <th>Fecha de estado</th>
            <th>Tipo atención</th>
          </tr>
          <tr class="filters">
            <th>
              <input class="form-control form-control-sm" placeholder="Buscar #" [(ngModel)]="filters.codigo">
            </th>
            <th>
              <select class="form-select form-select-sm" [(ngModel)]="filters.sucursal">
                <option value="">Todas las sucursales</option>
                <option *ngFor="let sucursal of sucursales" [value]="sucursal">{{ sucursal }}</option>
              </select>
            </th>
            <th>
              <input class="form-control form-control-sm" placeholder="Buscar paciente" [(ngModel)]="filters.paciente">
            </th>
            <th>
              <select class="form-select form-select-sm" [(ngModel)]="filters.estado">
                <option value="">Todos los estados</option>
                <option *ngFor="let estado of estados" [value]="estado">{{ estado }}</option>
              </select>
            </th>
            <th>
              <input class="form-control form-control-sm" placeholder="Fecha / hora" [(ngModel)]="filters.fecha">
            </th>
            <th>
              <input class="form-control form-control-sm" placeholder="Tipo atención" [(ngModel)]="filters.tipo">
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of filteredRows; trackBy: trackByToma">
            <td>
              <span class="order-chip">{{ item.COD_TOMS }}</span>
            </td>
            <td>{{ item.DIR_SURC }}</td>
            <td>
              <button type="button" class="patient-link" (click)="abrirDetalle(item, detalleModal)">
                {{ item.NOM_CLI }}
                <i class="fa fa-chevron-right"></i>
              </button>
            </td>
            <td>
              <span [class]="estadoClass(item.EST_TOMS)">{{ item.EST_TOMS || 'Sin estado' }}</span>
            </td>
            <td>{{ formatFecha(item.FECREG_TOMS) }}</td>
            <td>
              <span class="attention-pill">
                <span class="estado-dot" [style.background-color]="estadoTomaColor(item.EST_TOM)"></span>
                {{ estadoTomaTexto(item.EST_TOM) }}
              </span>
            </td>
          </tr>
          <tr *ngIf="filteredRows.length === 0">
            <td colspan="6">
              <div class="empty-state">
                <i class="fa fa-search"></i>
                <h6>No hay registros para los filtros aplicados</h6>
                <p>Prueba limpiando filtros o actualizando la información.</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>

<ng-template #detalleModal let-modal>
  <div class="sample-modal">
    <div class="sample-modal__header">
      <div>
        <span class="eyebrow">Detalle de orden</span>
        <h5>Exámenes a realizar</h5>
      </div>
      <button type="button" class="btn-close" aria-label="Cerrar" (click)="modal.dismiss()"></button>
    </div>

    <div class="sample-modal__body">
      <div class="detail-summary" *ngIf="selectedRow">
        <article>
          <span># Toma</span>
          <strong>{{ selectedRow.COD_TOMS }}</strong>
        </article>
        <article>
          <span>Sucursal</span>
          <strong>{{ selectedRow.DIR_SURC }}</strong>
        </article>
        <article class="detail-summary__wide">
          <span>Paciente</span>
          <strong>{{ selectedRow.NOM_CLI }}</strong>
        </article>
        <article>
          <span>Estado</span>
          <strong>{{ selectedRow.EST_TOMS }}</strong>
        </article>
        <article>
          <span>Fecha estado</span>
          <strong>{{ formatFecha(selectedRow.FECREG_TOMS) }}</strong>
        </article>
      </div>

      <div class="detail-table-card">
        <div class="detail-table-card__head">
          <div>
            <h6>Productos de laboratorio</h6>
            <p>{{ detalleRows.length }} examen(es) encontrado(s)</p>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table detail-table">
            <thead>
              <tr>
                <th>Examen</th>
                <th>Especialidad</th>
                <th>Tubo</th>
                <th>Tipo muestra</th>
                <th>Método / equipo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="loadingDetalle">
                <td colspan="5">
                  <div class="loading-state loading-state--compact">
                    <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                    <span>Cargando exámenes...</span>
                  </div>
                </td>
              </tr>
              <tr *ngFor="let producto of detalleRows">
                <td>
                  <strong>{{ producto.NOM_PRO }}</strong>
                </td>
                <td>{{ producto.NOM_SUBCAT || '-' }}</td>
                <td>{{ producto.nombre_tubo || '-' }}</td>
                <td>{{ producto.NOM_TIPMUES || '-' }}</td>
                <td>{{ producto.metodo_equipo || '-' }}</td>
              </tr>
              <tr *ngIf="!loadingDetalle && detalleRows.length === 0">
                <td colspan="5">
                  <div class="empty-state empty-state--compact">
                    <i class="fa fa-flask"></i>
                    <h6>No hay productos de laboratorio en esta orden.</h6>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="sample-modal__footer">
      <button type="button" class="btn btn-secondary" (click)="modal.close()">Cerrar</button>
    </div>
  </div>
</ng-template>
